module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newPhase
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Phase")])]), _vm._v(" "), _c('p', [_vm._v("Drag the phases to re-order.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return _c('th', [_vm._v(_vm._s(field.label))])
  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "tbody"
    },
    on: {
      "update": _vm.saveReOrder
    },
    model: {
      value: (_vm.phases),
      callback: function($$v) {
        _vm.phases = $$v
      },
      expression: "phases"
    }
  }, [_vm._l((_vm.phases), function(phase) {
    return _c('tr', [_c('td', [_c('i', {
      staticClass: "fa fa-arrows"
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (phase.label),
        expression: "phase.label"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (phase.label)
      },
      on: {
        "change": _vm.save,
        "input": function($event) {
          if ($event.target.composing) { return; }
          phase.label = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm pull-right",
      on: {
        "click": function($event) {
          _vm.deleteRecord(phase)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])])])
  }), _vm._v(" "), (_vm.phases.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("You don't have any phases")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": _vm.newPhase
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Phase")])])])])], 1), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText,
      "button-class": _vm.confirmDialog.buttonClass
    },
    on: {
      "confirm": function($event) {
        _vm.executeDelete(_vm.confirmDialog.parameters)
      },
      "closeModal": function($event) {
        _vm.confirmDialog.visible = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.confirmDialog.message) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1f47906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Phases.vue
// module id = 305
// module chunks = 0